import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { EventListItem } from "src/app/models/events/event-list-item";
import { EventService } from "src/app/services/event/event.service";
import { LoadingService } from "src/app/services/loading/loading.service";

@Component({
  selector: "app-user-add-event-popup",
  templateUrl: "./user-add-event-popup.component.html",
  styleUrls: ["./user-add-event-popup.component.scss"],
})
export class UserAddEventPopupComponent implements OnInit {
  @Input() action: (events: EventListItem[]) => void = () => {};
  events: EventListItem[] = [];
  caches: EventListItem[] = [];
  display: boolean = false;
  count: number = 0;
  pages: number = 0;
  isSelectedEverything: boolean = false;
  filters: any = {
    searchInput: null,
    idOrder: null,
    dateOrder: true,
    statuses: 3,
  };

  open(): void {
    this.display = true;
  }

  close(): void {
    this.display = false;
  }

  selectEverything(): void {
    if (this.isSelectedEverything == true) {
      this.caches = [];
      this.events.forEach((ev) => (ev.selected = false));
    } else {
      this.fetchEverything();
    }
  }

  fetch(): void {
    this.loadingService.startLoading();
    this.eventService
      .getEvents(this.getQueryString())
      .pipe(finalize(() => this.loadingService.stopLoading()))
      .subscribe((value) => {
        this.count = value.count;
        this.pages =
          value.count != 0
            ? Math.ceil(value.count / this.filters.itemsPerPage)
            : 0;
        this.events = value.list;
        this.events.forEach((e) => {
          if (this.caches.find((event) => event.uuId == e.uuId))
            e.selected = true;
        });
      });
  }
  fetchEverything(): void {
    this.loadingService.startLoading();
    this.eventService
      .getEvents(this.getEverythingQueryString())
      .pipe(finalize(() => this.loadingService.stopLoading()))
      .subscribe({
        next: (value) => {
          this.caches = value.list;
          this.events.forEach((e) => {
            if (this.caches.find((event) => event.uuId == e.uuId))
              e.selected = true;
          });
        },
      });
  }

  selectAll(): void {
    if (this.isSelectedAll) {
      this.events.forEach((e) => {
        e.selected = false;
        this.caches.splice(
          this.caches.findIndex((u) => u.uuId == e.uuId),
          1,
        );
      });
    } else {
      this.caches = this.caches.concat(
        this.events.filter((event) => event.selected == false),
      );
      this.events.forEach((e) => (e.selected = true));
    }
  }

  get isSelectedAll(): boolean {
    return this.events.every((event) => event.selected == true);
  }

  cacheEvent(e: EventListItem): void {
    if (e.selected) this.caches.push(e);
    else
      this.caches.splice(
        this.caches.findIndex((event) => event.uuId == e.uuId),
        1,
      );
  }
  confirm(): void {
    console.log("2-2", this.caches);
    this.action(this.caches);
    this.close();
  }

  constructor(
    private route: ActivatedRoute,
    private eventService: EventService,
    private loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((value) => {
      this.filters.page = parseInt(value.page) || 1;
      this.filters.itemsPerPage = parseInt(value.itemsPerPage) || 20;
      this.fetch();
    });
  }
  private getEverythingQueryString(): string {
    return (
      "?start=0" +
      "&limit=5000" +
      (this.filters.searchInput
        ? "&filterString=" + this.filters.searchInput
        : "") +
      (this.filters.statuses ? "&statuses=" + this.filters.statuses : "") +
      (this.filters.idOrder != null
        ? "&orderById=" + String(this.filters.idOrder)
        : "") +
      (this.filters.dateOrder != null
        ? "&orderByDate=" + String(this.filters.dateOrder)
        : "")
    );
  }
  private getQueryString(): string {
    return (
      "?start=" +
      (this.filters.page - 1) * this.filters.itemsPerPage +
      "&limit=" +
      this.filters.itemsPerPage +
      (this.filters.searchInput
        ? "&filterString=" + this.filters.searchInput
        : "") +
      (this.filters.statuses ? "&statuses=" + this.filters.statuses : "") +
      (this.filters.idOrder != null
        ? "&orderById=" + String(this.filters.idOrder)
        : "") +
      (this.filters.dateOrder != null
        ? "&orderByDate=" + String(this.filters.dateOrder)
        : "")
    );
  }
  searchFilterAction: (input: string) => void = ((input: string) => {
    this.filters.searchInput = input;
    this.filters.page = 1;
    this.fetch();
  }).bind(this);
}
